import React from 'react';

const ServiceDetailPage = ({
  title,
  heading,
  intro,
  imageSrc,
  imageAlt,
  features = [],
  deliverables = [],
  outcomes = [],
  stats = [],
  sideTitle,
  sideText,
}) => {
  return (
    <>
      <div className="breadcrumb-area">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="breadcrumb_box text-center">
                <h2 className="breadcrumb-title">{title}</h2>
                <ul className="breadcrumb-list">
                  <li className="breadcrumb-item"><a href="/">Home</a></li>
                  <li className="breadcrumb-item"><a href="/technologies">Services</a></li>
                  <li className="breadcrumb-item active">{title}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="service-details-wrapper section-space--ptb_100">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="content-area">
                <div className="service-details-content">
                  <p className="section-sub-title mb-20" style={{ color: '#64b1a6' }}>App Core Innovation</p>
                  <h1>{heading}</h1>
                  <p className="lead">{intro}</p>

                  {imageSrc ? (
                    <div className="mb-40">
                      <img
                        src={imageSrc}
                        alt={imageAlt || title}
                        className="img-fluid"
                        style={{ borderRadius: '24px', width: '100%', maxHeight: '320px', objectFit: 'cover' }}
                      />
                    </div>
                  ) : null}

                  <h3 className="mt-40">How we approach it</h3>
                  <p>
                    App Core Innovation is a new startup company focused on practical software delivery, meaningful design, and dependable product growth. We help founders and businesses launch faster without compromising clarity or quality.
                  </p>

                  <h3 className="mt-40">What the engagement includes</h3>
                  <ul>
                    {features.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>

                  {deliverables.length > 0 ? (
                    <>
                      <h3 className="mt-40">Typical deliverables</h3>
                      <ul>
                        {deliverables.map((item, index) => (
                          <li key={index}>{item}</li>
                        ))}
                      </ul>
                    </>
                  ) : null}

                  {outcomes.length > 0 ? (
                    <>
                      <h3 className="mt-40">Expected outcomes</h3>
                      <div className="case-study-box mt-30">
                        <ul>
                          {outcomes.map((item, index) => (
                            <li key={index}>{item}</li>
                          ))}
                        </ul>
                      </div>
                    </>
                  ) : null}
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="sidebar-area">
                <div className="sidebar-widget mb-50">
                  <h5 className="widget-title mb-30">{sideTitle || 'Why partner with App Core'}</h5>
                  <p className="small">{sideText || 'We combine product thinking, design clarity, and development execution to help startups and growing teams launch confidently.'}</p>
                </div>

                {stats.length > 0 ? (
                  <div className="sidebar-widget">
                    <h5 className="widget-title mb-30">Service snapshot</h5>
                    {stats.map((item, index) => (
                      <div className="metric-item mb-20" key={index}>
                        <p className="metric-label">{item.label}</p>
                        <p className="metric-value" style={{ color: '#64b1a6', fontSize: '24px', fontWeight: 'bold' }}>{item.value}</p>
                      </div>
                    ))}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ServiceDetailPage;
